import { User } from "@dandelion/core";
import { injectable } from "inversify";
import { jwtDecode } from "jwt-decode";
import { ref } from "vue";

@injectable()
export class UserProvider {
    constructor() {
    }

    public goToLogIn() {
        console.log(import.meta.env.VITE_APP_REMOTE_AUTH);
        if (import.meta.env.VITE_APP_REMOTE_AUTH === "false") {
            return; // TODO: select first / random user?
        }
        window.location.href =
            import.meta.env.VITE_APP_AUTH_BASE_URL +
            'Identity/Account/Login?ReturnUrl=' +
            encodeURIComponent(import.meta.env.VITE_APP_AUTH_RETURN_URL);
    }

    public async logOut() {
        window.localStorage.removeItem('jwtToken');
        window.location.href = import.meta.env.VITE_APP_AUTH_BASE_URL + 'Identity/Account/Logout';
    }

    public verifyToken(token: string) {
        const decoded: any = jwtDecode(token);
        const validLog = !!(decoded.exp && (decoded.exp * 1000 > Date.now()));
        const currentUser = new User(decoded.email, decoded.CentreCode, decoded['http://schemas.microsoft.com/ws/2008/06/identity/claims/role']);
        if (!validLog) {
            window.localStorage.removeItem('jwtToken');
        }
        return { validLog, currentUser };
    }

    public getToken() {
        let token = window.localStorage.getItem('jwtToken');
        if (!token) {
            const params = new URLSearchParams(window.location.search);
            const jwtToken = params.get('jwt');
            if (jwtToken) {
                window.localStorage.setItem('jwtToken', jwtToken!);
                token = jwtToken;
            }
        }
        return token;
    }

    public tryAuthenticate() {
        const token = this.getToken();
        const isLogged = ref(false);
        if (token) {
            isLogged.value = this.verifyToken(token).validLog;
        }
        if (!isLogged.value) {
            this.goToLogIn();
        }
    }
}